<div class="input-group flex-nowrap">
  <div class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
    <ngx-editor [editor]="editor" [(ngModel)]="localValue" (ngModelChange)="onValueChange($event)"
      [className]="'rich-textarea'" [disabled]="false" [placeholder]="placeholder"></ngx-editor>
  </div>
</div>
